export default __webpack_public_path__ + "static/media/save-color.daa6eddb.svg";